import { GoogleSignInButton } from '@/auth/GoogleSignInButton';
import { useAuth } from '@/auth/AuthContext';
import { hasGoogleClientId } from '@/config/api';
import { useCallback, useState } from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import './Login.css';

type RouteState = {
  from?: string;
};

export function Login() {
  const navigate = useNavigate();
  const location = useLocation();
  const { login, loginWithGoogle } = useAuth();
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState<string | null>(null);
  const [submitting, setSubmitting] = useState(false);
  const [googleSubmitting, setGoogleSubmitting] = useState(false);

  const from = ((location.state as RouteState | null)?.from || '/market').toString();
  const googleEnabled = hasGoogleClientId();

  const onSubmit = async (event: React.FormEvent) => {
    event.preventDefault();
    setError(null);
    setSubmitting(true);
    try {
      await login(username, password);
      navigate(from, { replace: true });
    } catch (e) {
      setError(e instanceof Error ? e.message : '登录失败');
    } finally {
      setSubmitting(false);
    }
  };

  const onGoogleCredential = useCallback(
    async (credential: string) => {
      setError(null);
      setGoogleSubmitting(true);
      try {
        await loginWithGoogle(credential);
        navigate(from, { replace: true });
      } catch (e) {
        setError(e instanceof Error ? e.message : 'Google 登录失败');
      } finally {
        setGoogleSubmitting(false);
      }
    },
    [from, loginWithGoogle, navigate]
  );

  return (
    <div className="login-page">
      <form className="login-card" onSubmit={onSubmit}>
        <Link to="/landing" className="login-brand">
          <span>A</span>
          ArbX
        </Link>
        <div>
          <p className="login-kicker">Secure workspace</p>
          <h2>统一登录</h2>
        </div>
        <label>
          用户名或邮箱
          <input value={username} onChange={(e) => setUsername(e.target.value)} required />
        </label>
        <label>
          密码
          <input
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            type="password"
            required
          />
        </label>
        {error ? <p className="login-error">{error}</p> : null}
        <button type="submit" disabled={submitting || googleSubmitting}>
          {submitting ? '登录中...' : '登录'}
        </button>
        {googleEnabled ? (
          <>
            <div className="login-divider">
              <span>或</span>
            </div>
            <GoogleSignInButton
              disabled={submitting || googleSubmitting}
              onCredential={(credential) => void onGoogleCredential(credential)}
              onError={setError}
            />
          </>
        ) : null}
        <p className="login-footer">
          需要新开套利账户？ <Link to="/register">前往注册</Link>
          <br />
          <Link to="/landing">返回产品介绍</Link>
        </p>
      </form>
    </div>
  );
}
